import React, { Component } from 'react';
 import "./publicright.css"
import TimeAgo from 'react-timeago'
class Notices extends Component {
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    console.log("props----------------->", this.props.title)
    return (
        
               <div className="aticle-body-notice">  
                    <div className="aticle-sub-notice">  
                         <p className="aticle-date"> <TimeAgo date={this.props.date} /></p>
                        <i className="fas fa-user-tie icon-link"></i>   {this.props.name}
                    </div>
                     <div className="aticle-sub-message-puble">
                          
                     <div className="notice-title-body-head">  <p>{this.props.title}</p></div>

                     <p>{this.props.body}</p>
                     </div>
                       
         
                    <hr className="notice-line-publie"/>
           </div>     

    )

}





}

export default Notices;



// WEBPACK FOOTER //
// ./src/component/public/notiecs.js